import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

import type { AccountEvent } from "@/store/types";

type AccountEventRow = AccountEvent & { accountName: string | null };

export default function AccountEventsTable({ events }: { events: AccountEventRow[] }) {
  const firstEvent = events[0];

  return (
    <TableContainer>
      <Box sx={{ display: "flex", gap: 3, mb: 1.5 }}>
        <Typography variant="body2">
          <strong>Feed ID:</strong> {firstEvent.feedId ?? "-"}
        </Typography>
        <Typography variant="body2">
          <strong>Item ID:</strong> {firstEvent.itemId ?? "-"}
        </Typography>
      </Box>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Account Name</TableCell>
            <TableCell>Account ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Member Availability</TableCell>
            <TableCell>Device Volume</TableCell>
            <TableCell>Trigger</TableCell>
            <TableCell>Created At</TableCell>
            <TableCell>Content ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {events.map((row) => (
            <TableRow key={row.id} sx={{ "&:last-child td": { border: 0 } }}>
              <TableCell>{row.id}</TableCell>
              <TableCell>{row.accountName ?? "-"}</TableCell>
              <TableCell>{row.accountId}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.memberAvailability ?? "-"}</TableCell>
              <TableCell>{row.deviceVolume ?? "-"}</TableCell>
              <TableCell>{row.triggerType ?? "-"}</TableCell>
              <TableCell>{new Date(row.createdAt).toLocaleString()}</TableCell>
              <TableCell>{row.contentId ?? "-"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
